export default {
  //Permissões gerais
  INTEGRA_MANAGER__OWNER: {
    index: 1,
    value: "integra_manager__owner"
  },
  INTEGRA_MANAGER__ADMIN: {
    index: 2,
    value: "integra_manager__admin"
  },
  INTEGRA_MANAGER__FINANCIER: {
    index: 3,
    value: "integra_manager__financier"
  },
  INTEGRA_MANAGER__FINANCIER_BASIC: {
    index: 4,
    value: "integra_manager__financier_basic"
  },
  TMS__OWNER: {
    index: 5,
    value: "tms__owner"
  },
  TMS__ADMIN: {
    index: 6,
    value: "tms__admin"
  },
  AGE__OWNER: {
    index: 7,
    value: "age__owner"
  },
  AGE__ADMIN: {
    index: 8,
    value: "age__admin"
  },
  INV__OWNER: {
    index: 9,
    value: "inv__owner"
  },
  INV__ADMIN: {
    index: 10,
    value: "inv__admin"
  },
  BI__OWNER: {
    index: 11,
    value: "bi__owner"
  },
  BI__ADMIN: {
    index: 12,
    value: "bi__admin"
  },
  WMS__OWNER: {
    index: 13,
    value: "wms__owner"
  },
  WMS__ADMIN: {
    index: 14,
    value: "wms__admin"
  },
  PRT__OWNER: {
    index: 15,
    value: "prt__owner"
  },
  PRT__ADMIN: {
    index: 16,
    value: "prt__admin"
  },
  FINANCE__OWNER: {
    index: 17,
    value: "finance__owner"
  },
  FINANCE__ADMIN: {
    index: 18,
    value: "finance__admin"
  },
  QUOTATION__OWNER: {
    index: 19,
    value: "quotation__owner"
  },
  QUOTATION__ADMIN: {
    index: 20,
    value: "quotation__admin"
  },
  SIMULATION__OWNER: {
    index: 21,
    value: "simulation__owner"
  },
  SIMULATION__ADMIN: {
    index: 22,
    value: "simulation__admin"
  },
  BID_FRP__OWNER: {
    index: 23,
    value: "bid_frp__owner"
  },
  BID_FRP__ADMIN: {
    index: 24,
    value: "bid_frp__admin"
  },
  FISCAL_BOOKKEEPING__OWNER: {
    index: 25,
    value: "fiscal_bookkeeping__owner"
  },
  FISCAL_BOOKKEEPING__ADMIN: {
    index: 26,
    value: "fiscal_bookkeeping__admin"
  },
  FOUR_PL_MANAGER__OWNER: {
    index: 27,
    value: "four_pl_manager__owner"
  },
  FOUR_PL_MANAGER__ADMIN: {
    index: 28,
    value: "four_pl_manager__admin"
  },
  APP_DELIVERY__OWNER: {
    index: 29,
    value: "app_delivery__owner"
  },
  APP_DELIVERY__ADMIN: {
    index: 30,
    value: "app_delivery__admin"
  },
  FINANCE__TAKER_BASIC: {
    index: 31,
    value: "finance__taker_basic"
  },
  FINANCE__MANAGER_PROSPECTOR: {
    index: 32,
    value: "finance__manager_prospector"
  },
  FINANCE__MANAGER_AGENT: {
    index: 33,
    value: "finance__manager_agent"
  },
  FINANCE__FINTECH_COMMERCIAL: {
    index: 34,
    value: "finance__fintech_commercial"
  },
  FINANCE__FINTECH_ANALYST: {
    index: 35,
    value: "finance__fintech_analyst"
  },
  TRACKING__OWNER: {
    index: 36,
    value: "tracking__owner"
  },
  TRACKING__ADMIN: {
    index: 37,
    value: "tracking__admin"
  },
  INTEGRA_MANAGER__SHIPPER_MANAGER: {
    index: 38,
    value: "integra_manager__shipper_manager"
  },
  BILLING__OWNER: {
    index: 39,
    value: "billing__owner"
  },
  BILLING__ADMIN: {
    index: 40,
    value: "billing__admin"
  },
  INTEGRA_MANAGER__SHIPPER_COMMERCIAL: {
    index: 42,
    value: "integra_manager__shipper_commercial"
  },
  INTEGRA_MANAGER__QUOTATION_APPROVER_USER: {
    index: 43,
    value: "integra_manager__quotation_approver_user"
  },



  /* OWNER: {
     index: 1,
     value: "owner",
   },
   ADMIN: {
     index: 2,
     value: "admin",
   },
   FINANCIER: {
     index: 3,
     value: "financier",
   },
   FINANCIER_BASIC: {
     index: 4,
     value: "financier_basic",
   },
   FINANCE_MANAGER_ADMIN:{
     index: 20,
     value: "finance_manager_admin"
   },
   FINANCE_MANAGER_AGENT:{
     index: 21,
     value: "finance_manager_agent"
   },
   FINTECH_COMMERCIAL: {
     index: 21,
     value: "fintech_commercial",
   },
   FINTECH_ANALYST: {
     index: 22,
     value: "fintech_analyst",
   },*/
  ALL_MODULES: {
    INTEGRA_MANAGER: {
      index: 5,
      value: 'integra_manager',
      color: 1
    },
    TMS: {
      index: 6,
      value: 'tms',
      color: 2
    },
    AGE: {
      index: 7,
      value: 'age',
      color: 7
    },
    INV: {
      index: 8,
      value: 'inv',
      color: 6
    },

    BI: {
      index: 9,
      value: 'bi',
      color: 4
    },
    WMS: {
      index: 10,
      value: 'wms',
      color: 5
    },
    PRT: {
      index: 11,
      value: 'prt',
      color: 8
    },
    FINANCE: {
      index: 12,
      value: 'finance',
      color: 10
    },
    QUOTATION: {
      index: 13,
      value: 'quotation',
      color: 11
    },
    SIMULATION: {
      index: 14,
      value: 'simulation',
      color: 12
    },
    BID_FRP: {
      index: 15,
      value: 'bid_frp',
      color: 13
    },
    FISCAL_BOOKKEEPING: {
      index: 16,
      value: 'fiscal_bookkeeping',
      color: 14
    },
    FOUR_PL_MANAGER: {
      index: 17,
      value: 'four_pl_manager',
      color: 3
    },
    APP_DELIVERY: {
      index: 18,
      value: 'app_delivery',
      color: 9
    },
    TRACKING: {
      index: 19,
      value: 'tracking',
      color: 4
    },
    BILLING: {
      index: 20,
      value: 'billing',
      color: 14
    },
  },
  //Grupo das permissões relacionadoas aos módulos do sistema
  MODULES: {
    LOGISTICS: {
      INTEGRA_MANAGER: {
        index: 5,
        value: 'integra_manager',
        color: 1
      },
      TMS: {
        index: 6,
        value: 'tms',
        color: 2
      },
      FOUR_PL_MANAGER: {
        index: 17,
        value: 'four_pl_manager',
        color: 3
      },
      BI: {
        index: 9,
        value: 'bi',
        color: 4
      },
      WMS: {
        index: 10,
        value: 'wms',
        color: 5
      },
      INV: {
        index: 8,
        value: 'inv',
        color: 6
      },
      AGE: {
        index: 7,
        value: 'age',
        color: 7
      },
      PRT: {
        index: 11,
        value: 'prt',
        color: 8
      },
      APP_DELIVERY: {
        index: 18,
        value: 'app_delivery',
        color: 9
      },
      TRACKING: {
        index: 19,
        value: 'tracking',
        color: 4
      },
      BILLING: {
        index: 20,
        value: 'billing',
        color: 14
      },
    },
    COSTS_AND_FINANCIAL: {
      FINANCE: {
        index: 12,
        value: 'finance',
        color: 10
      },
      QUOTATION: {
        index: 13,
        value: 'quotation',
        color: 11
      },
      SIMULATION: {
        index: 14,
        value: 'simulation',
        color: 12
      },
      BID_FRP: {
        index: 15,
        value: 'bid_frp',
        color: 13
      },
      FISCAL_BOOKKEEPING: {
        index: 16,
        value: 'fiscal_bookkeeping',
        color: 14
      },
    },
  }
};
